import { Button, Form, Input, Spin } from 'antd';
import cx from 'classnames';
import React, { useState } from 'react';
import { batch } from 'react-redux';
import { Agreement } from '..';
import { accountApi } from '../../../api';
import { getFullVelocityUrl } from '../../../Helper';
import { LoginResponseStatusCode, LogOnViewModel } from '../../../model/AccountModel';
import styles from './logOnForm.module.scss';

const fullVelocityUrl: string = getFullVelocityUrl();
const backgroundImage: string = 'backgroundImage';
const companyName: string = 'Identiv, Inc.';
const usernameInput: string = 'LogOnInfo_UserName';
const passwordInput: string = 'LogOnInfo_Password';

const LogOnForm: React.FC = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [loginButtonDisabled, setLoginButtonDisabled] = useState<boolean>(false);
	const [username, setUsername] = useState<string>();
	const [password, setPassword] = useState<string>();
	const [logOnViewModel, setLogOnViewModel] = useState<LogOnViewModel>(getLogOnViewModel());

	const handleInput = (e: React.ChangeEvent<HTMLInputElement>, stateFunction: (param: string) => void) => {
		batch(() => {
			setLogOnViewModel({
				...logOnViewModel,
				Message: '',
			});
			const value: string = e.currentTarget.value ? e.currentTarget.value : '';
			stateFunction(value);
		});
	};

	const handleOnFinishForm = () => {
		batch(() => {
			setIsLoading(true);
			setLoginButtonDisabled(true);
		});

		const model: LogOnViewModel = {
			...logOnViewModel,
			LogOnInfo: {
				...logOnViewModel.LogOnInfo,
				UserName: username,
				Password: password,
			},
		};
		accountApi.logOn(model).then(response => {
			batch(() => {
				setIsLoading(false);
				setLogOnViewModel({
					...response,
					LogOnInfo: {
						...response.LogOnInfo,
						UserName: '',
						Password: '',
					},
				});
				if (response.Success) {
					window.location.href = `${location.origin}${response.RedirectTo}`;
				} else {
					setPassword('');
					if (!logOnViewModel.LogOnInfo.ShowEULAAgreement && !logOnViewModel.LogOnInfo.ShowUserNotification) {
						setLoginButtonDisabled(false);
					}
				}
			});
		});
	};

	const hasError: boolean =
		logOnViewModel.StatusCode !== LoginResponseStatusCode.None &&
		logOnViewModel.StatusCode !== LoginResponseStatusCode.Success &&
		logOnViewModel.StatusCode !== LoginResponseStatusCode.LogoutSuccess;

	return (
		<div className={styles.container}>
			<div className={styles.image} style={{ backgroundImage: `url(${fullVelocityUrl}Content/Images/ID-red-pattern.jpg)` }} />
			<Spin tip={`${_('Loading')}...`} spinning={isLoading} wrapperClassName={styles.spin} size='large'>
				<div className={styles.loginContainer}>
					<Form name='logOnForm' autoComplete='off' onFinish={handleOnFinishForm}>
						<img className={styles.logo} alt={companyName} title={backgroundImage} src={`${fullVelocityUrl}Content/Images/logo.png`} />
						<div className={styles.inputsContainer}>
							{!logOnViewModel.LogOnInfo.IsWindowsAuthenticationEnabled && (
								<>
									<label htmlFor={usernameInput}>
										<strong>{_('OperatorName')}</strong>
									</label>
									<Input
										id={usernameInput}
										aria-label={_('OperatorName')}
										maxLength={50}
										className={styles.input}
										placeholder={_('OperatorName')}
										onChange={e => handleInput(e, setUsername)}
										value={username}
									/>
									<label htmlFor={passwordInput}>
										<strong>{_('Password')}</strong>
									</label>
									<Input.Password
										id={passwordInput}
										aria-label={_('Password')}
										maxLength={50}
										className={cx({
											[styles.error]: hasError,
											[styles.input]: true,
										})}
										placeholder={_('Password')}
										onChange={e => handleInput(e, setPassword)}
										value={password}
									/>
								</>
							)}
							{logOnViewModel.Message && (
								<label
									className={cx({
										[styles.errorMessage]: hasError,
										[styles.successMessage]: logOnViewModel.StatusCode === LoginResponseStatusCode.LogoutSuccess,
									})}>
									{logOnViewModel.Message}
								</label>
							)}
							<Button
								id={'loginSubmitBtn'}
								className={styles.buttonTypeContainer}
								htmlType='submit'
								type='primary'
								disabled={loginButtonDisabled}>
								{_('Login')}
							</Button>
							{logOnViewModel.Version && (
								<div className={styles.aboutDiv}>
									<label id='aboutDescription'>{_('Version')}: </label>
									<label id={`aboutVersion`}>{logOnViewModel.Version}</label>
								</div>
							)}
						</div>
					</Form>
				</div>
				{(logOnViewModel.LogOnInfo.ShowEULAAgreement || logOnViewModel.LogOnInfo.ShowUserNotification) && <Agreement logOnViewModel={logOnViewModel} />}
			</Spin>
		</div>
	);
};

export { LogOnForm };
